import axios from "axios";
import { API_URL } from "constants";

export const fetch = ({ filtersValue, companyId }) => {
  const url = `${API_URL}/${companyId}/orders/fetch`;
  return axios.post(url, { filtersValue }).then((response) => response.data);
};

export const fetchCustomerOrders = ({ customerId, companyId }) => {
  const url = `${API_URL}/${companyId}/orders/customers/${customerId}/fetch`;
  return axios.get(url).then((response) => response.data);
};

export const post = (data) => {
  const url = `${API_URL}/${data.company}/orders/post`;
  return axios.post(url, data).then((response) => response.data);
};

export const fetchById = (orderId, company) => {
  const url = `${API_URL}/${company}/orders/fetchById/${orderId}`;
  return axios.get(url).then((response) => response.data);
};

export const patch = (data) => {
  const url = `${API_URL}/${data.company}/orders/patch/${data.id}`;
  return axios.patch(url, data).then((response) => response.data);
};

/**
 * Close or reopen an order explicitly, rather than toggling whatever state it
 * happens to be in. Closing stops recurring invoicing and freezes the invoice
 * settings; reopening is restricted to Admin/Master server-side.
 */
export const setOrderClosed = ({ companyId, orderId, isClosed }) => {
  const url = `${API_URL}/${companyId}/orders/${orderId}/closed`;
  return axios.post(url, { isClosed }).then((response) => response.data);
};

/**
 * Mark (or unmark) an order whose contract will be signed later — it can be
 * invoiced meanwhile. Master only server-side.
 */
export const setOrderContractDeferred = ({ companyId, orderId, contractDeferred }) => {
  const url = `${API_URL}/${companyId}/orders/${orderId}/contract-deferred`;
  return axios.post(url, { contractDeferred }).then((response) => response.data);
};

/**
 * Other orders of the company whose external contract number is exactly
 * `number` — for the order form's (non-blocking) duplicate warning.
 */
export const checkExternalNumber = ({ companyId, number, excludeId }) => {
  const url = `${API_URL}/${companyId}/orders/external-number-check`;
  return axios
    .get(url, { params: { number, ...(excludeId ? { excludeId } : {}) } })
    .then((response) => response.data);
};

/**
 * Attach (or replace, while unsent) the signed PDF of an external contract.
 * `fileId` is the row `files/upload` returned.
 */
export const attachOrderDocument = ({ companyId, orderId, data }) => {
  const url = `${API_URL}/${companyId}/orders/${orderId}/document`;
  return axios.post(url, data).then((response) => response.data);
};

export const patchOrderInvoiceSettings = ({
  companyId,
  orderId,
  data,
}) => {
  const url = `${API_URL}/${companyId}/orders/${orderId}/invoice-settings`;
  return axios.patch(url, data).then((response) => response.data);
};
